<template>
  <div class="container">
    <div class="homeTop"><span>专题活动</span></div>
    <div class="listBox">
      <van-list
        class="actListBox"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        @load="getSpecialList"
      >
        <div
          class="listItem"
          v-for="(item, index) in list"
          :key="index"
          @click="toSpecialDetail(item.SpecialId)"
        >
          <van-image fit="cover" :src="item.Cover" />
          <div class="title">{{ item.Name }}</div>
          <div class="time">
            活动时间：{{ item.StartDateDesc }} ~ {{ item.EndDateDesc }}
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { List, Image } from "vant";
import { getShareData } from "@/utils/share";
import { liveSpecialList } from "@/api/online";
export default {
  name: "specificAct",
  components: {
    "van-list": List,
    "van-image": Image,
  },
  data() {
    return {
      list: [],
      pageIndex: 1,
      total: 0,
      error: false,
      loading: false,
      finished: false,
    };
  },
  methods: {
    //跳转专题详情
    toSpecialDetail(id) {
      this.$router.push({ path: "/specificActDetail", query: { sid: id } });
    },

    //获取专题列表
    getSpecialList() {
      var that = this;
      var data = {
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
        IsRec: 0,
        Keyword: "",
      };
      liveSpecialList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },
  mounted() {
    getShareData(
      window.location.href,
      "2021阿拉丁网上照明展专题活动中心"
    );
  },
};
</script>
<style lang="less" scoped>
.container {
  .homeTop {
    height: 150px;
    position: relative;
    background-image: url("https://files.alighting.com/Cover/actBg20210427.png");
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center bottom;
    span {
      font-size: 25px;
      color: #fff;
      font-weight: bold;
      position: absolute;
      top: 90px;
      left: 63px;
    }
  }
  .listBox {
    margin: 17px 10px 50px 10px;
    .listItem {
      margin-bottom: 32px;
      .van-image {
        width: 100%;
        height: 202px;
        display: block;
      }
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        margin-top: 11px;
      }
      .time {
        color: #666;
        font-size: 13px;
        margin-top: 7px;
      }
    }
  }
}
</style>